import { KEEP_ASSIGNEE } from '../constants/RoutingTypes';
import get from 'transmute/get';
export const checkIsRoutingRules = routingRules => routingRules !== KEEP_ASSIGNEE;
export const getAssignByAvailability = routingRules => {
  let assignByAvailability = false;
  if (checkIsRoutingRules(routingRules)) {
    assignByAvailability = Boolean(get('shouldFilterToAvailable', routingRules));
  }
  return assignByAvailability;
};